import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const CheckIcon = forwardRef<SVGSVGElement, IconProps>(function CheckIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7891 6.70424C14.0703 6.42875 14.0703 5.9821 13.7891 5.70661C13.5078 5.43113 13.0518 5.43113 12.7705 5.70661L7.57349 10.797L5.22946 8.5011C4.9482 8.22561 4.4922 8.22561 4.21094 8.5011C3.92969 8.77659 3.92969 9.22324 4.21094 9.49872L7.06404 12.2933C7.14923 12.3767 7.25044 12.4349 7.35798 12.4678C7.60556 12.5436 7.8867 12.4855 8.08285 12.2934L13.7891 6.70424Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
